<app-pesquisa [(showDialog)]="pesquisarDialog" (pessoa)="selecionarPessoa($event)"></app-pesquisa>

@if (registroNaoSelecionado) {
    <app-empty [titulo]="'Registro nao selecionado'" [descricao]="'Selecione um medico para emitir documentos.'" [acao]="abrirPesquisa" [iconBotao]="'pi pi-search'" [labelBotao]="'Selecionar medico'"></app-empty>
} @else {
    <div class="solicitacao-documentos-wrapper">
        <app-card-content [border]="false" [headerColor]="true" [icon]="'pi pi-id-card'" [title]="'Emissão VALID'" [subtitle]="'Solicitação de CIM, CPM e Certificado Digital'">
            <form [formGroup]="form" class="solicitacao-documentos">
                <!-- Card 1: Configuração e Status -->
                <app-card-content [headerColor]="false" [title]="'Configuração'" [icon]="'pi pi-cog'">
                    @if (exibirTipoCarteira) {
                        <div class="campo-tipo">
                            <label>Tipo de carteira</label>
                            <p-select
                                [options]="tiposCarteira"
                                formControlName="tipoCarteira"
                                optionLabel="label"
                                optionValue="value"
                                appendTo="body"
                                [disabled]="carregandoStatus() || enviandoSolicitacao()"
                                (onChange)="consultarStatus(true)"
                            ></p-select>
                        </div>
                    }

                    <section class="opcoes-operacionais">
                        <label class="controle-opcao" [class.selecionado]="form.controls.preSolicitacao.value">
                            <p-checkbox formControlName="preSolicitacao" [binary]="true" [disabled]="carregandoStatus() || enviandoSolicitacao()"></p-checkbox>
                            <span>
                                <strong>Pre-solicitação</strong>
                                <small>Envia CIM como pre-solicitação quando habilitado.</small>
                            </span>
                        </label>

                        <p-button icon="pi pi-refresh" label="Atualizar status" styleClass="p-button-outlined" [loading]="carregandoStatus()" [disabled]="carregandoStatus() || enviandoSolicitacao()" (onClick)="consultarStatus(true)"></p-button>
                    </section>

                    @if (mensagens.length > 0) {
                        <section class="mensagens-area" aria-live="polite">
                            @for (mensagem of mensagens; track mensagem.titulo + mensagem.tipo) {
                                <article class="mensagem-card" [class.ok]="mensagem.tipo === 'success'" [class.info]="mensagem.tipo === 'info'" [class.aviso]="mensagem.tipo === 'warn'" [class.erro]="mensagem.tipo === 'error'">
                                    <span class="mensagem-icone">
                                        <i [class]="mensagem.icone"></i>
                                    </span>
                                    <div class="mensagem-conteudo">
                                        <strong>{{ mensagem.titulo }}</strong>
                                        @if (mensagem.descricao) {
                                            <span>{{ mensagem.descricao }}</span>
                                        }
                                        @if ((mensagem.itens?.length ?? 0) > 0) {
                                            <ul>
                                                @for (item of mensagem.itens ?? []; track item) {
                                                    <li>{{ item }}</li>
                                                }
                                            </ul>
                                        }
                                    </div>
                                </article>
                            }
                        </section>
                    }

                    @if (respostaSolicitacao) {
                        <section class="resultado-solicitacao">
                            <div class="resultado-cabecalho">
                                <span class="secao-icone">
                                    <i class="pi pi-check-circle"></i>
                                </span>
                                <div>
                                    <strong>Solicitação registrada</strong>
                                    @if (respostaSolicitacao.mensagem || respostaSolicitacao.retorno) {
                                        <span>{{ respostaSolicitacao.mensagem || respostaSolicitacao.retorno }}</span>
                                    }
                                </div>
                            </div>

                            @if (documentosSolicitados.length > 0) {
                                <div class="resultado-grid">
                                    @for (documento of documentosSolicitados; track documento.tipo) {
                                        <article class="resultado-documento" [class.ok]="documento.habilitado" [class.aviso]="!documento.habilitado">
                                            <strong>{{ documento.descricao || documento.tipo }}</strong>
                                            <span>{{ resultadoDocumentoDescricao(documento) }}</span>
                                        </article>
                                    }
                                </div>
                            }
                        </section>
                    }
                </app-card-content>

                <!-- Card 2: Documentos a serem emitidos -->
                <app-card-content [headerColor]="false" [title]="'Documentos a serem emitidos'" [icon]="'pi pi-file-plus'">
                    <div class="documentos-grid">
                        <label class="documento-card" [class.selecionado]="form.controls.emitirCim.value" [class.bloqueado]="desabilitado('CIM')">
                            <div class="documento-conteudo">
                                <span class="documento-icone">
                                    <i class="pi pi-id-card"></i>
                                </span>
                                <div>
                                    <strong>Cédula de Identidade Médica - CIM</strong>
                                    <small>Física, digital e Certificado de Atributo</small>
                                </div>
                            </div>
                            <p-checkbox formControlName="emitirCim" [binary]="true" [disabled]="desabilitado('CIM')"></p-checkbox>
                        </label>

                        <label class="documento-card" [class.selecionado]="form.controls.emitirCpm.value" [class.bloqueado]="desabilitado('CPM')">
                            <div class="documento-conteudo">
                                <span class="documento-icone">
                                    <i class="pi pi-briefcase"></i>
                                </span>
                                <div>
                                    <strong>Carteira Profissional Médica - CPM</strong>
                                    <small>Física e digital</small>
                                </div>
                            </div>
                            <p-checkbox formControlName="emitirCpm" [binary]="true" [disabled]="desabilitado('CPM')"></p-checkbox>
                        </label>

                        <label class="documento-card" [class.selecionado]="form.controls.emitirCd.value" [class.bloqueado]="desabilitado('CD')">
                            <div class="documento-conteudo">
                                <span class="documento-icone">
                                    <i class="pi pi-shield"></i>
                                </span>
                                <div>
                                    <strong>Certificado Digital A3</strong>
                                    <small>Em nuvem, padrão ICP Brasil</small>
                                </div>
                            </div>
                            <p-checkbox formControlName="emitirCd" [binary]="true" [disabled]="desabilitado('CD')"></p-checkbox>
                        </label>
                    </div>
                </app-card-content>

                <!-- Card 3: Tipo de requisição -->
                @if ((form.controls.emitirCim.value && opcoesRequisicao('CIM').length > 0) || (form.controls.emitirCpm.value && opcoesRequisicao('CPM').length > 0)) {
                    <app-card-content [headerColor]="false" [title]="'Tipo de requisição'" [icon]="'pi pi-list-check'">
                        <div class="requisicoes">
                            @if (form.controls.emitirCim.value && opcoesRequisicao('CIM').length > 0) {
                                <div class="field">
                                    <label>Requisição CIM</label>
                                    <p-select [options]="opcoesRequisicao('CIM')" formControlName="tipoRequisicaoCim" optionLabel="label" optionValue="value" appendTo="body" [disabled]="desabilitado('CIM')"></p-select>
                                </div>
                            }

                            @if (form.controls.emitirCim.value && form.controls.tipoRequisicaoCim.value === '2') {
                                <div class="field">
                                    <label>Motivo da reimpressão CIM</label>
                                    <p-select [options]="motivosReimpressao" formControlName="motivoReimpressaoCim" optionLabel="label" optionValue="value" appendTo="body" [disabled]="desabilitado('CIM')"></p-select>
                                </div>
                            }

                            @if (form.controls.emitirCpm.value && opcoesRequisicao('CPM').length > 0) {
                                <div class="field">
                                    <label>Requisição CPM</label>
                                    <p-select [options]="opcoesRequisicao('CPM')" formControlName="tipoRequisicaoCpm" optionLabel="label" optionValue="value" appendTo="body" [disabled]="desabilitado('CPM')"></p-select>
                                </div>
                            }

                            @if (form.controls.emitirCpm.value && form.controls.tipoRequisicaoCpm.value === '2') {
                                <div class="field">
                                    <label>Motivo da reimpressão CPM</label>
                                    <p-select [options]="motivosReimpressao" formControlName="motivoReimpressaoCpm" optionLabel="label" optionValue="value" appendTo="body" [disabled]="desabilitado('CPM')"></p-select>
                                </div>
                            }
                        </div>
                    </app-card-content>
                }

                <!-- Rodapé -->
                <footer class="rodape-card">
                    <div class="cimweb">
                        <i class="pi pi-external-link"></i>
                        <span>O acompanhamento da carteira deve ser realizado no CIMWeb: <a href="http://sistemas.cfm.org.br/cim" target="_blank" rel="noreferrer">http://sistemas.cfm.org.br/cim</a></span>
                    </div>

                    <div class="botoes">
                        <p-button
                            icon="pi pi-send"
                            label="Solicitar Documentos"
                            [loading]="enviandoSolicitacao()"
                            [disabled]="!status || carregandoStatus() || enviandoSolicitacao()"
                            (onClick)="enviarSolicitacao()"
                            [appCan]="roleEmissaoEmitir"
                        ></p-button>
                    </div>
                </footer>
            </form>
        </app-card-content>
    </div>
}
